<template>
  <v-container fluid class="grey lighten-5 pb-10" style="min-height: 100vmin">
    <v-row>
      <v-col cols="12">
        <v-tabs v-if="this.$isMobile()">
          <v-tab
            v-for="i in controle"
            :to="i.route"
            :key="i"
            color="#E74242"
            class="elevation-0"
            @click="this.controleSelecionado = i.name"
            >{{ i.name }}</v-tab
          >
          > >
        </v-tabs>
        <v-tabs v-else>
          <v-tab
            v-for="i in controle"
            :to="i.route"
            :key="i"
            color="#E74242"
            class="elevation-0"
            @click="this.controleSelecionado = i.name"
            >{{ i.name }}
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row>
      <RouterView></RouterView>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  // eslint-disable-next-line vue/multi-word-component-names
  name: "dadosCad",
  data: () => ({
    adicionais: [],
    controleSelecionado: "Dados da Empresa",
    controle: [
    ],
  }),
  watch: {},
  computed: {
    ...mapGetters(["database", "produtos", "categorias"]),
  },
  methods: {},
  async created() {
    const ordemDesejada = [
      "Dados da Empresa",
      "Formas De Pagamento",
      "Banner",
      "Tele",
      "Pagamento No App"
    ];
    if (this.database.telas.dadosCadastrais) {
      const abas = this.database.telas.dadosCadastrais.filter(aba => aba.header === true);
      const dadosOrdenados = [...abas].sort(
        (a, b) => ordemDesejada.indexOf(a.value) - ordemDesejada.indexOf(b.value)
      );
      for (let controle of dadosOrdenados) {
        if (controle.value == "Dados da Empresa") {
          this.controle.push({ name: "Dados da Empresa", route: "/dadoscadastrais/dadosempresa" });
        } else if (controle.value == "Tele") {
          this.controle.push({ name: "Tele", route: "/dadoscadastrais/tele" });
        } else if (controle.value == "Formas De Pagamento") {
          this.controle.push({ name: "Formas De Pagamento", route: "/dadoscadastrais/formapgto" });
        } else if (controle.value == "Banner") {
          this.controle.push({ name: "Banner", route: "/dadoscadastrais/banner" });
        } else if (controle.value == "Pagamento No App") {
          this.controle.push({ name: "Pagamento No App", route: "/dadoscadastrais/pagamento" });
        }
      }
    }
    if (this.$route.path == "/dadoscadastrais") {
      this.$router.push("/dadoscadastrais/dadosempresa");
    }
  },
  mounted() {},
};
</script>
<style scoped>
.grey {
  animation: transitionIn 0.75s;
}
@keyframes transitionIn {
  from {
    opacity: 0;
    transform: rotateX(-10deg);
  }
  to {
    opacity: 1;
    transform: rotateX(0);
  }
}
</style>
